// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";


// main function
export default function CloneContract({ onMenuClose, rowContractData }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    return (

        <Box>
            {(rowContractData.contractLevel === "X") &&
                <MenuItem>
                            <ListItemIcon>
                                <SupervisorAccountIcon fontSize="small"/>
                            </ListItemIcon>
                            <ListItemText>Clone</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
